import React from 'react';
import Section from '../Section/Section';
import Typography from '../Typography/Typography';
import { Button, ButtonGroup } from '../Button/Button';
import { useTranslation } from 'utils/translation';
import Spacer from '../Spacer/Spacer';

type Props = {
  onConfirm(): void;
  onCancel(): void;
  title?: string;
  question?: React.ReactNode;
  cancelText?: string;
  confirmText?: string;
};

const Confirmation = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  const {
    children,
    onConfirm,
    onCancel,
    title = t('confirmation.title'),
    question = t('confirmation.question'),
    cancelText = t('confirmation.answer_no'),
    confirmText = t('confirmation.answer_yes'),
  } = props;

  return (
    <Section>
      <Typography variant="h1" align="center">
        {title}
      </Typography>
      <Spacer size={4} />
      <Typography style={{ maxWidth: '600px' }} align="center">
        {question}
      </Typography>
      <Spacer size={children !== null ? 4 : 6} />
      {children}
      <ButtonGroup align="right">
        <Button onClick={onConfirm}>{confirmText}</Button>
        <Button variant="text" onClick={onCancel}>
          {cancelText}
        </Button>
      </ButtonGroup>
    </Section>
  );
};

export default Confirmation;
